export function formatExternalStatus(status: string): string {
    let formatted = status.replace(/[_-]/g, ' ');

    formatted = formatted.toLowerCase();
    formatted = formatted.replace(/\b\w/g, (char) => char.toUpperCase());

    return formatted;
}

export function formatDelimitedLabel(value: string): string {
    return value
        .split(/[._-]+/u)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
}

export const formatOfficeName = (
    officeName: string | null | undefined,
): string => {
    if (!officeName) {
        return '—';
    }
    // Title case: capitalize first letter of each word
    return officeName
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export function formatDuration(durationMs: number | null | undefined): string {
    if (durationMs === null || durationMs === undefined) {
        return '—';
    }
    const totalSeconds = Math.floor(durationMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}
